module.exports = __webpack_public_path__ + "img/come-vict-02.fb809d1c.jpg";